<template>
  <div class="container">
    <h3 class="mb-2 text-center">Términos y Condiciones de Competencia</h3>

    <div class="terminos-box p-3 bg-white rounded shadow-sm">
      <p class="aviso-categoria">
        <strong>Nota:</strong> En esta competencia es posible fusionar tu categoría en
        caso de que no se complete la cantidad mínima requerida de peleadores.
      </p>

      <h5 class="mt-3">CARTA RESPONSIVA</h5>

      <p>
        ACEPTO y confirmo haber leído todas las condiciones del TORNEO/EVENTO denominado:
        <strong>"EVOLVE GRAPPLING PRO"</strong>, entendido y aceptado el compromiso de
        excluir de responsabilidad total a <strong>"EVOLVE GRAPPLING PRO"</strong>, así
        como la administración, los empleados y los organizadores de que su participación
        en el (EVOLVE GRAPPLING PRO "número del evento") Y se asume que es completamente
        responsabilidad del firmante, y por ello se excluye a los citados la
        responsabilidad que derive de dicho evento.
      </p>

      <p>
        Se manifiesta bajo protesta de decir verdad que el participante no cuenta con
        enfermedad de tipo cardiovascular o alguna otra que ponga en riesgo su vida, ni la
        de los demás durante su participación en el EVENTO.
      </p>

      <p>
        Se entiende y acepta que durante el evento se contará con servicio de médicos o
        paramédicos de primeros auxilios, proporcionados por el comité organizador; en el
        caso de paramédicos, no pueden recetar y administrar medicamentos, por lo que, en
        caso de que ocurra alguna lesión más grave, los gastos correrán por cuenta de mi
        persona.
      </p>

      <p>
        Se autoriza a los organizadores del evento a grabar (total o parcialmente) toda
        participación, por medio de fotografías, películas, TV., Radio, Video, o cualquier
        otro medio conocido o por conocerse para uso comercial, publicitario, etc., según
        consideren necesario, renunciando a cualquier derecho a recibir cualquier tipo de
        compensación.
      </p>

      <p>
        De igual forma, el comité organizador no se hace responsable por los participantes
        seleccionados por cada equipo. Así mismo se declara que no existe ni existirá
        relación laboral alguna entre el participante y los organizadores del EVENTO por
        dicha participación en este.
      </p>

      <p>
        Los organizadores del EVENTO podrán cancelar o modificar las condiciones del
        evento sin ninguna responsabilidad para con los participantes. Se entiende y
        acepta que el comité organizador no se hace responsable de daños que cause el
        participante o quien suscribe, y en caso de que suceda y se maltrate cualquier
        estructura durante el EVENTO, el firmante responderá por los daños, más las multas
        que deriven del mismo, no siendo limitativas al campo de juego, instalaciones
        deportivas en donde se realicen las actividades propias del evento arriba
        mencionado.
      </p>

      <p>
        En ese sentido, renuncio a cualquier derecho para iniciar cualquier tipo de acción
        legal en contra de <strong>"EVOLVE GRAPPLING PRO"</strong> y/o LOS PATROCINADORES
        COMERCIALES, por alteraciones en la salud, lesiones y/o daños (incluso la muerte
        accidental) relacionados con, o derivados de, mi participación y/o de mi
        hijo(a)/pupilo en las distintas actividades del EVENTO programadas por los
        ORGANIZADORES.
      </p>

      <p>
        Acepto el aviso de privacidad y estoy de acuerdo en que la organización de este
        evento me envíe información referente al EVENTO y/o sus patrocinadores.
      </p>
    </div>
  </div>
</template>
